var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v(_vm._s(_vm.$t("headers.page-not-found")))]),_c('p',[_vm._v(" "+_vm._s(_vm.$t("view.page-not-found.text"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }